$(document).ready(function () {

    $(document).on('click', '.open-tab', function () {
        let tabID = $(this).attr('data-tab');
        $('#' + tabID).slideToggle(300);
        $(this).toggleClass('visible-tab');
    })

    const tabs = $('.open-tab');
    let IDs;

    for (let i = 0; i < tabs; i++) {
        IDs = i++;
    }
    console.log(IDs);
})



// WEBPACK FOOTER //
// ./scripts/routes/tabs.js